import qweBaseField from "../BaseField";
import { getAllUser, getUserByFilter } from "../../../apis/httpHelper";

export default {
    mixins:[qweBaseField],
    data:function(){
        return {
            userOptions:[],
            remoteState: false,
            useScript: false
        }
    },
    localUser:[],

    scriptOptionsFunc:{},

    created:function(){
        if(this.selfSetting.UseOptions){
            this.scriptOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.OptionsScript);
            let context = this.buildFormContext();
            this.scriptOptionsFunc(context, context.Content, this);

            let optionsRely = this.selfSetting.OptionsRelyFields || [];
            optionsRely.forEach(x => {
                this.$watch("data." + x, function (newVal, oldVal) {
                    let context = this.buildFormContext();
                    this.scriptOptionsFunc(context, context.Content, this);
                })
            });
        }
        else{
            this.getUsers();
        }
    },
    computed:{
        selectItems:function(){
            return this.userOptions.filter(x=> x.name == this.data[this.name]);
        }
    },
    methods:{
        getUsers:function(){
            let self = this;
            let names = (this.data[this.name] || []);
            getAllUser(names)
            .then(x=>{
                let userOptions = x.Result.Options.map(x=>{
                    return {
                        value: x.Value,
                        label: x.Text,
                        Value: x.Value,
                        Label: x.Text
                    }
                });
                self.userOptions = userOptions;
                if(this.$refs.userSelect != undefined){
                    this.$refs.userSelect.initOptions(userOptions);
                }
            })
        },

        setOptions:function(filter){
            let self = this;
            getUserByFilter(filter).then(x=>{
                let userOptions = x.Result.Options.map(x=>{
                    return {
                        value: x.Value,
                        label: x.Text,
                        Value: x.Value,
                        Label: x.Text
                    }
                });
                self.userOptions = userOptions;
                if(this.$refs.userSelect != undefined){
                    this.$refs.userSelect.initOptions(userOptions);
                }
            })
        }
    }
}